import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveDeliveryTypes } from './index';

// Api's
import { deliveryTypeApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getDeliveryTypesSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      deliveryTypeApi.getByDeliveryType
    );
    if (response.data.result) {
      yield put(saveDeliveryTypes(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveDeliveryTypes(null, true, resultError.messagesDataError));
    }
  }
}
